import Vue from 'vue';

const initialState = () => {
    return {
        addToCartIsLoading: false,
        addToCartError: null,
    }
};

const state = initialState();

const actions = {
    async addProductToQuote({commit, dispatch}, productPayload: object): Promise<void> {
        commit('SET_ADD_TO_CART_LOADING', true);

        try {
            const {data} = await this.$solarClient.post(
                '/api/quote/item', {
                    cartItem: productPayload,
                }, {timeout: 25000}
            );

            if (data) {
                dispatch('ProductView/addSkuToAddedItems', data['sku'], {root: true});
                window.dispatchEvent(new CustomEvent('CheckoutAddedProductToCartEvent'));
                dispatch('trackKlaviyoAddedToCart', {...data, qty: productPayload['qty'] ?? data['qty']});
            }
        } catch (error) {
            console.error(error);
            commit('SET_ADD_TO_CART_ERROR', error);
        } finally {
            commit('SET_ADD_TO_CART_LOADING', false);
        }
    },
    async trackKlaviyoAddedToCart(_context, item: object): Promise<void> {
        if (!window['klaviyo'] || !window.Config['klaviyo_public_key']) {
            return;
        }

        try {
            const [{data: checkoutUrl}, {data: totals}] = await Promise.all([
                this.$solarClient.get('/api/custom/checkout/restore-url'),
                this.$solarClient.get('/api/checkout/totals'),
            ]);
            const totalsItem = (totals?.['items'] || []).find((totalsItem) => totalsItem['item_id'] === item['item_id']);

            window['klaviyo'].track('Added to Cart', {
                $value: totals?.['subtotal_incl_tax'],
                AddedItemProductName: item['name'],
                AddedItemSKU: item['sku'],
                AddedItemPrice: totalsItem?.['price_incl_tax'] ?? item['price'],
                AddedItemQuantity: item['qty'],
                CheckoutURL: checkoutUrl,
            });
        } catch (e) {
            //
        }
    }
};

const mutations = {
    SET_ADD_TO_CART_LOADING(state: object, payload: boolean): void {
        Vue.set(state, 'addToCartIsLoading', payload);
    },
    SET_ADD_TO_CART_ERROR(state: object, payload: object): void {
        Vue.set(state, 'addToCartError', payload);
    }
};

const getters = {
    getAddToCartIsLoading: (state: object) => state['addToCartIsLoading'],
    getAddToCartError: (state: object) => state['addToCartError'],
};

const CheckoutQuote = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};

export default CheckoutQuote;
